import * as Connection from './connectionMatchers';
import * as Data from './data';
import * as Design from './desginMatchers';
import * as Layout from './layout';
import * as LinkTypeMatchers from './links';
import * as Props from './propsMatchers';
import * as Style from './styleMatchers';
import * as DS from './typings/documentServices';
export * from './data'; // TODO: remove this export
export * from './styleMatchers';
export * from './structureMatchers';
export * from './breakpointMatchers';
export * from './links';
export * from './sizes';
export * from './cssDefaults';
export * from './layout';
export * from './extendedDocumentServicesAPI';
export * from './manifestMatchers';
export * from './images';
export * from './propsMatchers'; // TODO: remove this export
export * from './connectionMatchers';
export * from './appDataMatchers';
export { Layout, LinkTypeMatchers, Data, Props, Design, Connection, Style };
export * from './breakpointIdType';
export * from './styleDSMockAPI';
export const DocumentServicesAPI = {
    name: 'Document Services API',
    layer: 'SITE',
    public: true,
};
export { DS };
//# sourceMappingURL=index.js.map